import { render, staticRenderFns } from "./CabinetElectricity.vue?vue&type=template&id=1f65bab3&scoped=true&"
import script from "./CabinetElectricity.vue?vue&type=script&lang=js&"
export * from "./CabinetElectricity.vue?vue&type=script&lang=js&"
import style0 from "./CabinetElectricity.vue?vue&type=style&index=0&id=1f65bab3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f65bab3",
  null
  
)

export default component.exports